export default {
  lineAt: state => state.lineAt,
  linkLine: state => state.linkLine,
  adminContactLineLink: state => state.adminContactLineLink || state.linkLine,
  defaultAdminContactLineLink: state => state.defaultAdminContactLineLink || state.linkLine,
  domains: state => state.domains,
  activeDomains: state => state.domains.filter(domain => domain.active === true),
  partnerReferralHost: state => state.partnerReferralHost,
  isSettingsLoaded: state => state.isLoaded
}
